import { render, staticRenderFns } from "./monthly-obligations.vue?vue&type=template&id=35c8978b&scoped=true"
import script from "./monthly-obligations.vue?vue&type=script&lang=js"
export * from "./monthly-obligations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c8978b",
  null
  
)

export default component.exports